import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
  Col,
  HelpBlock,
} from "react-bootstrap";
import { style } from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";

import LocalizedStrings from "react-localization";
// import { MapsLocalPizza } from "material-ui/svg-icons";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    memberEmailTitle: "Member Email",
    userAddedMessage1: "User has been added to your recipient list !",
    validError: "Please ensure your email and name are valid !",
    addedError: "This user is already added !",
    groupError:
      "This user is not part of this group ! Please contact the system administrator !",
    duplicateError: "Please make sure email & name are not duplicated !",
    emptyError: "Please enter something to edit !",
    addGroupTitle: "Add Group",
    emailHeader: "Email address",
    nameHeader: "Name",
    submitButton: "Submit",
    closeButton: "Close",
  },
  ja: {
    memberEmailTitle: "メンバーのメール",
    userAddedMessage1: "ユーザーが受信者リストに追加されました！",
    validError: "メールと名前が有効であることを確認してください！",
    addedError: "このユーザーはすでに追加されています！",
    groupError:
      "このユーザーはこのグループの一員ではありません！ システム管理者に連絡してください！",
    duplicateError: "メールと名前が重複していないことを確認してください！",
    emptyError: "編集する内容を入力してください！",
    addRecipientTitle: "メンバー追加",
    emailHeader: "Eメール",
    nameHeader: "名前",
    submitButton: "追加",
    closeButton: "閉じる",
  },
  es: {
    memberEmailTitle: "Correo Electrónico del Miembro",
    userAddedMessage1:
      "¡El usuario ha sido añadido a su lista de destinatarios!",
    validError:
      "¡Por favor asegúrese de que su correo electrónico y nombre sean válidos!",
    addedError: "¡Este usuario ya ha sido añadido!",
    groupError:
      "¡Este usuario no es parte de este grupo! ¡Por favor contacte al administrador del sistema!",
    duplicateError:
      "¡Asegúrese de que el correo electrónico y el nombre no estén duplicados!",
    emptyError: "¡Por favor ingrese algo para editar!",
    addGroupTitle: "Añadir Grupo",
    emailHeader: "Dirección de correo electrónico",
    nameHeader: "Nombre",
    submitButton: "Enviar",
    closeButton: "Cerrar",
  },
});

class AddGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      name: "",
      tempMembersArr: [],
      selectedMembersToAdd: [],
      // Displaying the add user form
      show: props.show,
      locklistArray: [],
      hidden: true,
      _notificationSystem: null,
    };

    // Handlers for displaying the add user form
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // this.handleHide = this.handleHide.bind(this);

    // Handlers for submitting to firebase
    // this.onSubmit = this.onSubmit.bind(this);

    // Handler for Force Update
    // this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    // this.renderAddToRecipient = this.renderAddToRecipient.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  // Handlers for displaying the add user modal
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleHide() {
    this.setState({ hidden: true });
    this.forceUpdateHandler();
  }

  handleDisplay() {
    this.setState({ hidden: false });
    this.forceUpdateHandler();
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'

    if (lvl === "success") {
      this.setState({
        selectedMembersToAdd: [],
      });
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  //!TODO: SUBMIT TO FIREBASE
  onSubmit() {
    // console.log(this.input.value)
    const groupName = this.input.value;
    // const groupId = fire
    //   .database()
    //   .ref()
    //   .push().key;
    const timeCreated = Date.now();
    // const dataToPush = { groupName: groupName, timeCreated: timeCreated }
    // console.log(groupId)

    var userGroupsRefPush = fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid)
      .child("userGroups")
      .push();

    userGroupsRefPush.set({
      groupName: groupName,
      groupId: userGroupsRefPush.key,
      timeCreated: timeCreated,
    });
    this.showNotification(
      "Group successfully added ! Reloading...",
      "success",
      "tc",
      3
    );
    this.handleClose();
    setTimeout(() => {
      window.location.reload(false);
    }, 3000);
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Button
          // bsSize="large"
          id="addGroupBtn"
          onClick={this.handleShow}
        >
          <i className="fa fa-plus" /> Add Group
        </Button>
        <Modal
          dialogClassName="modal-50w"
          show={this.state.show}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.addGroupTitle}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <section>
              <label>Enter Name :</label>
              <FormControl
                // onKeyPress={this.handleKeyPress}
                placeholder="key in your group name"
                aria-describedby="basic-addon1"
                inputRef={(input) => (this.input = input)}
                // disabled={this.state.isDisabled}
              />
            </section>
          </Modal.Body>
          <Modal.Footer>
            <div className={"flex"}>
              <Button
                className="submitBtn"
                type="submit"
                onClick={this.onSubmit}
              >
                {localizationStrings.submitButton}
              </Button>
              <Button onClick={this.handleClose} className="closeBtn">
                {localizationStrings.closeButton}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddGroupModal;
